//import { useDispatch } from "react-redux";//Vishy 2025-02-18 build warning not used, so removed
//import actions from "../redux/Actions";//Vishy 2025-02-18 build warning not used, so removed
//import { store } from "../redux/Store";//Vishy 2025-02-18 build warning not used, so removed
//import { handleLogout } from "./logout";//Vishy 2025-02-18 build warning not used, so removed

// Claude: normalises all backend error shapes into a single human-readable string 27-04-2026
// Shapes handled:
//   { message: string }              — HttpException(obj, status)
//   { message: string[] }            — NestJS built-in ValidationPipe
//   { error: { message: string } }   — NormalException (VALIDATION_ERROR / UNEXPECTED)
//   plain string body                — HttpException(string, status) sent via response.send()
export const errorHandler = (err: any) => {
  console.error("Full error:", err);
  const data = err?.response?.data;
  let msg: any = data?.message || data?.error?.message || err?.data?.message;
  if (Array.isArray(msg)) msg = msg.join(", ");
  if (!msg && typeof data === "string") msg = data;
  return msg || "Something went wrong. Unable to connect with the server.";
};

export const responseHandler = (res: any) => {
  if (res.status === 200 || res.status === 201) {
    res.data.success = true;
  } else {
    res.data.success = false;
  }

  return res.data;
};

// Claude: 401/403 logout is handled centrally in axiosConfig interceptor 22-04-2026
export const errorResponseHandler = (err: any) => {
  return err;
};
